var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0036 23.1367C39.2199 23.5639 39.1422 24.0812 38.8098 24.4259C38.4774 24.7705 37.9633 24.867 37.5285 24.6664L31.905 22.0709C27.1787 19.8896 22.0209 18.8917 16.872 19.1264C16.8109 20.7798 16.7201 22.4324 16.5998 24.0834L16.4458 26.1961C16.3523 27.4778 14.9232 28.1943 13.8403 27.5023C9.14006 24.499 5.05393 20.6291 1.79971 16.0989L0.764286 14.6575C0.482543 14.2653 0.482543 13.737 0.764286 13.3448L1.7997 11.9034C5.05393 7.37329 9.14006 3.50339 13.8403 0.500044C14.9232 -0.191911 16.3523 0.524574 16.4458 1.80628L16.5998 3.91894C16.7031 5.33612 16.7846 6.75449 16.8443 8.17354H18.2912C26.3484 8.17354 33.721 12.7042 37.3609 19.8924L39.0036 23.1367Z",
    fill: "#187330"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.0423fa11.svg";
export { ForwardRef as ReactComponent };